import http from "./http-common";
class BjpService {
  getGlobalPercentage() {
    return http.get("/client-service/global-percentage");
  }

  getDepartmentPercentages() {
    return http.get("/client-service/department-percentages");
  }

    /**
     * {
     *  rude: '814500842018003',
     *  birth: '2014-02-11'
     * }
     */
  getStudentBenefitStatus(payload) {
    return http.post("/client-service/student-benefit-status", payload);
  }

  /**
   * @param {{ idCard: string, complement: string, birth: string }} payload
   */
  getHolderBenefitInformation(payload) {
    return http.post("/client-service/holder-benefit-information", payload);
  }
}

export default new BjpService();
